import messages from '../../../locale/jsonMessages';
import valid from 'card-validator';

const validate = values => {

  const errors = {}

  if (!values.licenseNumber) {
    errors.licenseNumber = messages.required;
  } else if (values.licenseNumber && values.licenseNumber.toString().trim() == '') {
    errors.licenseNumber = messages.invalid;
  }

  if (!values.firstName) {
    errors.firstName = messages.required;
  } else if (values.firstName && values.firstName.toString().trim() == '') {
    errors.firstName = messages.invalid;
  }

  if (!values.lastName) {
    errors.lastName = messages.required;
  } else if (values.lastName && values.lastName.toString().trim() == '') {
    errors.lastName = messages.invalid;
  }

  if (!values.day) {
    errors.day = messages.required;
  }

  if (!values.year) {
    errors.year = messages.required;
  }

  let monthValidationLabel = parseInt(values.month);
  if (isNaN(monthValidationLabel)) {
    errors.month = messages.required;
  }

  if (values.day && values.year && !isNaN(monthValidationLabel)) {
    const birthDate = new Date(Number(values.year), monthValidationLabel, Number(values.day));
    const hasValidBirthDate = birthDate.getFullYear() === Number(values.year)
      && birthDate.getMonth() === monthValidationLabel
      && birthDate.getDate() === Number(values.day);

    if (!hasValidBirthDate) {
      errors.day = messages.wrongDayChosen;
    } else {
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const beforeBirthday = today.getMonth() < birthDate.getMonth()
        || (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate());
      if (beforeBirthday) age--;
      if (age < 18) errors.year = messages.mustBe18OrOld;
    }
  }

  if (!values.country) {
    errors.country = messages.required;
  }

  if (!values.message) {
    errors.message = messages.required;
  } else if (values.message && values.message.toString().trim() == '') {
    errors.message = messages.required;
  }

  if (values.paymentType == 1 && !values.paymentCurrency) {
    errors.paymentCurrency = messages.required;
  }

  if (values.paymentType == 3) {
    if (!values.pawapayCountry) errors.pawapayCountry = messages.required;
    if (!values.pawapayCurrency) errors.pawapayCurrency = messages.required;
    if (!values.pawapayProvider) errors.pawapayProvider = messages.required;
  }

  if (values.paymentType == 2) {
    if (!values.name) {
      errors.name = messages.required;
    } else if (values.name && values.name.toString().trim() == '') {
      errors.name = messages.required;
    }

    if (!values.cardNumber) {
      errors.cardNumber = messages.required;
    } else {
      var numberValidation = valid.number(values.cardNumber);
      if (!numberValidation.isValid) {
        errors.cardNumber = messages.invalid;
      }
    }

    if (!values.expiryDate) {
      errors.expiryDate = messages.required;
    } else {
      var monthValidation = valid.expirationMonth(values.expiryDate);
      if (!monthValidation.isValid) {
        errors.expiryDate = messages.invalid;
      }
    }

    if (!values.expiryYear) {
      errors.expiryYear = messages.required;
    } else {
      var yearValidation = valid.expirationYear(values.expiryYear);
      if (!yearValidation.isValid) {
        errors.expiryYear = messages.invalid;
      }
    }

    if (!values.cvv) {
      errors.cvv = messages.required;
    } else {
      var maximumLength = 3;
      var numberValidation = valid.number(values.cardNumber);
      if (values.cardNumber && numberValidation.isValid) {
        var cardType = valid.number(values.cardNumber);
        if (cardType.card.type === 'american-express') {
          maximumLength = 4;
        }
      }
      var cvvValidation = valid.cvv(values.cvv, maximumLength);
      if (!cvvValidation.isValid) {
        errors.cvv = messages.invalid;
      }
    }
  }

  return errors;
}

export default validate;
